import React from 'react';
import { ValidatingFormComponent } from '@/formbuilder/formBuilder.constants';
import { FormulaItemTable, FormulaItemTableOption } from '@/tools/formula/FormulaItemTable.atom';
import { AdvancedSection } from '@/core/AdvancedParameters.atom';
import { useTranslation } from 'react-i18next';

export interface FormulaItemTableIF extends ValidatingFormComponent<string> {
  component: 'FormulaItemTableFormComponent';
  options: FormulaItemTableOption[];
  collapsible?: boolean;
  defaultCollapsed?: boolean;
  collapseLabel?: string;
}

export const FormulaItemTableFormComponent: React.FunctionComponent<FormulaItemTableIF> = (props) => {
  const { t } = useTranslation();

  const {
    options,
    extraClassNames,
    collapsible,
    defaultCollapsed = false,
    collapseLabel,
    tooltip,
    tooltipPlacement,
    tooltipDelay,
    testId,
    wrapperClassNames,
  } = props;

  const formulaItemTable = (
    <span className={extraClassNames} data-testid={testId}>
      <FormulaItemTable options={options} />
    </span>
  );

  const content = collapsible ? (
    <div data-testid={`${testId}-collapsible`} className={wrapperClassNames}>
      <AdvancedSection
        collapsed={defaultCollapsed}
        alternateName={collapseLabel}
        t={t}
        tooltip={tooltip}
        tooltipPlacement={tooltipPlacement}
        tooltipDelay={tooltipDelay}>
        {formulaItemTable}
      </AdvancedSection>
    </div>
  ) : (
    formulaItemTable
  );

  return <> {content} </>;
};
